export default __webpack_public_path__ + "static/media/logo.f0492bc5.svg";